import { AccessorsMutatorsDecorator, Model } from '../../helpers';

/**
 * @class BillingPaymentOption
 *
 * @property string id
 * @property string label
 * @property string type
 */
export class BillingPaymentOption extends Model {

    static get CREDIT_CARD() {

        return new BillingPaymentOption({
            id: 1,
            label: 'CREDIT_CARD/MADA',
            type: 'credit_card'
        });
    }

    static get PAYPAL() {

        return new BillingPaymentOption({
            id: 2,
            label: 'PAY_PAL',
            type: 'pay_pal'
        });
    }

    static get SADAD() {

        return new BillingPaymentOption({
            id: 3,
            label: 'SADAD',
            type: 'sadad'
        });
    }

    static get CASH_CHEQUE() {

        return new BillingPaymentOption({
            id: 4,
            label: 'CASH_CHEQUE',
            type: 'custom'
        });
    }

    static get POS() {

        return new BillingPaymentOption({
            id: 6,
            label: 'POS',
            type: 'custom'
        });
    }

    static get BANK_TRANSFER() {

        return new BillingPaymentOption({
            id: 7,
            label: 'BANK_TRANSFER',
            type: 'custom'
        });
    }

    static get CASH() {

        return new BillingPaymentOption({
            id: 4,
            label: 'CASH',
            type: 'custom'
        });
    }

    static get CHEQUE() {

        return new BillingPaymentOption({
            id: 5,
            label: 'CHEQUE',
            type: 'custom'
        });
    }

    static get VISA_CHECKOUT() {

        return new BillingPaymentOption({
            id: 8,
            label: 'VISA_CHECKOUT',
            type: 'visa_checkout',
        })
    }

    static get PAYMENT_OPTIONS() {

        return [
            this.CREDIT_CARD,
            this.PAYPAL,
            this.SADAD,
            // this.VISA_CHECKOUT,
            this.CASH_CHEQUE,
            this.POS,
            this.BANK_TRANSFER,
        ];
    }

    static get ALL_PAYMENT_OPTIONS() {

        return [
            this.CREDIT_CARD,
            this.PAYPAL,
            this.SADAD,
            this.CASH,
            this.CHEQUE,
            this.POS,
            this.BANK_TRANSFER,
            // this.VISA_CHECKOUT,
        ];
    }

    static get FORMATTED_METHOD() {

        return {
            [this.CREDIT_CARD.id]: 'CREDIT_CARD',
            [this.PAYPAL.id]: 'PAYPAL',
            [this.SADAD.id]: 'SADAD',
            [this.CASH.id]: 'CASH',
            [this.CHEQUE.id]: 'CHEQUE',
            [this.POS.id]: 'POS',
            [this.BANK_TRANSFER.id]: 'BANK_TRANSFER',
        }
    }
}

AccessorsMutatorsDecorator(
    'id',
    'label',
    'type',
)(BillingPaymentOption);



// WEBPACK FOOTER //
// ./src/pms-api/models/billing-payment-option.model.js